import React from 'react';
import { Button as MuiButton } from '@mui/material';
import PropTypes from 'prop-types';

const PrimaryButton = ({
  variant = 'contained',
  children,
  sx = {},
  ...props
}) => {
  const baseStyles = {
    fontFamily: 'IBM Plex Sans, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '0.875rem',
    lineHeight: '100%',
    textTransform: 'none',
    padding: '0.5rem 0.875rem',
    minHeight: '36px',
    borderRadius: '4px',
  };

  const variantStyles = {
    contained: {
      color: '#FFFFFF',
      background: '#0F172A',
      textAlign: 'right',
      letterSpacing: '0%',
      '&:hover': {
        background: '#1E293B',
      },
    },
    outlined: {
      color: '#525252',
      border: '0.83px solid #DDDFE3',
      textAlign: 'center',
      letterSpacing: '0.33px',
      verticalAlign: 'middle',
      '&:hover': {
        border: '0.83px solid #DDDFE3',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    text: {
      color: '#525252',
      textAlign: 'center',
      letterSpacing: '0%',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  };

  return (
    <MuiButton
      variant={variant}
      sx={{
        ...baseStyles,
        ...variantStyles[variant],
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

PrimaryButton.propTypes = {
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default PrimaryButton;

